import React from 'react';
import CustomTable from '../../components/CustomTable';
import {globales, colores, funciones } from '../../global';
import AuthService            from '../../AuthService';
import Request from 'superagent';
import Paper from '@material-ui/core/Paper';
import BarraBotones   from '../../components/Barra_menu';
import {withStyles} from '@material-ui/core/styles';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import CloseIcon from '@material-ui/icons/Close';
import DialogActions from '@material-ui/core/DialogActions';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import DialogContent          from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {virtual} from '../../components/VirtualListBox';
import Tooltip from '@material-ui/core/Tooltip';
import RefreshIcon from '@material-ui/icons/Refresh';
import PrintIcon from '@material-ui/icons/Print';
import {Table, TableSelection, TableSummaryRow, TableFixedColumns} from '@devexpress/dx-react-grid-material-ui';
import Select from '../../components/Select';
import InfoIcon from '@material-ui/icons/Info';
import InputAdornment from '@material-ui/core/InputAdornment';
import MenuItem from '@material-ui/core/MenuItem';
import {IntegratedFiltering} from '@devexpress/dx-react-grid';
import Grid from '@material-ui/core/Grid';
import DeleteIcon from '@material-ui/icons/Delete';
import 'date-fns';
import {KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import EventIcon from '@material-ui/icons/Event';
import RestoreIcon from '@material-ui/icons/Restore';
import CustomToolbar from '../../components/toolbarPicker';
import Reporte  from '../../components/Modalreporte';
import Avatar from '@material-ui/core/Avatar';
import PersonIcon from '@material-ui/icons/Person';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Divider from '@material-ui/core/Divider';
import CheckIcon from '@material-ui/icons/Check';
import AddIcon from '@material-ui/icons/Add';
import Crop54Icon from '@material-ui/icons/Crop54';
import Button from '@material-ui/core/Button';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Popover from '@material-ui/core/Popover';
import MenuList from '@material-ui/core/MenuList';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Fade from '@material-ui/core/Fade';

import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';

let Auth = new AuthService();
let tokenInfo = [];

var movil=/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

const styles = theme => ({
 
paper: { 
  borderRadius: globales.border_dialog,
  minWidth: !movil ? '65%' : undefined,  
  maxWidth: !movil ? '65%' : undefined, 
  minHeight: !movil ? '500px' : undefined,
  maxHeight: !movil ? '500px' : undefined, 
}, 
paperFact: { 
  borderRadius: globales.border_dialog,
  minWidth: !movil ? '320px' : "95%",  
  maxWidth: !movil ? '320px' : "95%", 
  height: !movil ? "550px" : undefined, 
  maxHeight: !movil ? "99%" : undefined
},
paperGest: { 
  borderRadius: globales.border_dialog,
  minWidth: !movil ? '50%' : undefined,  
  maxWidth: !movil ? '50%' : undefined, 
  minHeight: !movil ? '90%' : undefined,
  maxHeight: !movil ? '90%' : undefined, 
},
paperDetail: { 
  borderRadius: globales.border_dialog,
  minWidth: !movil ? '75%' : undefined,  
  maxWidth: !movil ? '75%' : undefined, 
  minHeight: !movil ? '500px' : undefined
},
paperDate: { 
  borderRadius: globales.border_dialog,
  minWidth: '350px', 
  maxWidth: '350px', 
},
paperConfirm: { 
  borderRadius: globales.border_dialog,
  minWidth: '320px', 
  maxWidth: '320px', 
},	
closeButton: {
  position: 'absolute',
  right: theme.spacing(1),
  top: theme.spacing(1),
  color: theme.palette.grey[500],
},
backdrop: {
  zIndex: 500000,
  color: '#fff', 
  flexDirection: 'column'
},
container: {
  display: 'flex',
  justifyContent: !movil ? 'center' : undefined, 
  alignItems: !movil ? "center" : "flex-start",
  flexDirection: !movil ? "row" : "column",
  paddingTop: "2px",
  paddingBottom: "5px", 
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1), 
},
textField: {
  marginRight: !movil ? theme.spacing(1) : undefined,         
},
textFieldFrm: {
  marginTop: theme.spacing(2), 
},
formControlSelect: {
  width: '100%',     
  textAlign: 'left',
  marginTop: theme.spacing(2),
},
formControlSelectModPago: {
  width: movil ? '100%' : '430px',  
  textAlign: 'left',
  marginBottom: 10,
  marginTop: 0,
},
});
const widthTable = !movil ? window.screen.width - (globales.tabla.marginleft + globales.tabla.marginright) : 1336;
const widthTableFact = !movil ? (window.screen.width * 0.65) : (1336 * 0.65);
const widthTableGest = !movil ? (window.screen.width * 0.50) : (1336 * 0.50);
const widthTableDeta = !movil ? (window.screen.width * 0.75) : (1336 * 0.75);  
const columns =  [  
  { name: 'ID_FACTURA', title: 'Factura'},
  { name: 'DESCRIPCION', title: 'Descripción'},
  { name: 'DESCRIPCION_TRANSACCION', title: 'Transacción'},
  { name: 'ESTATUS', title: 'Estado'},
  { name: 'FECHA_PROCESO', title: 'Fecha de proceso'},
  { name: 'FECHA_PAGO', title: 'Fecha de pago'},
  { name: 'BANCO', title: 'Banco'},
  { name: 'REFERENCIA1', title: 'Recibo de pago'},
  { name: 'MONTO_TOTAL', title: 'Monto total'},
  { name: 'MONTO_PAGADO', title: 'Monto pagado'},
];
const columnExtensions = [ 
  { columnName: 'ID_FACTURA', width: widthTable * 0.07},
  { columnName: 'DESCRIPCION', width: widthTable * 0.15},
  { columnName: 'DESCRIPCION_TRANSACCION', width: widthTable * 0.08, align: 'center'},
  { columnName: 'ESTATUS', width: widthTable * 0.07, align: 'center'},
  { columnName: 'FECHA_PROCESO', width: widthTable * 0.11, align: 'center'},  
  { columnName: 'FECHA_PAGO', width: widthTable * 0.11, align: 'center'},
  { columnName: 'BANCO', width: widthTable * 0.08},
  { columnName: 'REFERENCIA1', width: widthTable * 0.08},       
  { columnName: 'MONTO_TOTAL', width: widthTable * 0.08, align: 'right'},      
  { columnName: 'MONTO_PAGADO', width: widthTable * 0.08, align: 'right'},    
];

const columnsFact = [
  { name: 'ID_FACTURA', title: 'Factura'},
  { name: 'DESCRIPCION', title: 'Descripción'},
  { name: 'FECHA_PROCESO', title: 'Fecha de proceso'},
  { name: 'MONTO_TOTAL', title: 'Monto'},
];
const columnExtensionsFact = [ 
  { columnName: 'ID_FACTURA', width: widthTableFact * 0.15},
  { columnName: 'DESCRIPCION', width: widthTableFact * 0.40},
  { columnName: 'FECHA_PROCESO', width: widthTableFact * 0.15, align: 'center'},       
  { columnName: 'MONTO_TOTAL', width: widthTableFact * 0.15, align: 'right'},         
];
const totalSummaryItems = [
  { columnName: "ID_FACTURA", type: "count" },
  { columnName: "MONTO_TOTAL", type: "sum" },    
];

const columnsGest = [
  { name: 'ID_GESTION', title: 'ID_GESTION'},
  { name: 'CODIGO_TRANSACCION', title: 'Código'},
  { name: 'DESCRIPCION', title: 'Descripción'},
  { name: 'MONTO_ARANCEL', title: 'Monto'},
];
const columnExtensionsGest = [ 
  { columnName: 'ID_GESTION', width: 0},
  { columnName: 'CODIGO_TRANSACCION', width: widthTableGest * 0.14},
  { columnName: 'DESCRIPCION', width: widthTableGest * 0.52},       
  { columnName: 'MONTO_ARANCEL', width: widthTableGest * 0.16, align: 'right'},         
];

const settingFilter = [

  { columnName: 'MONTO_TOTAL',
     predicate: (value, filter, row) => {
                value = row.MONTO_TOTAL_SHOW.split(" ")[0] + ' ' + funciones.formatCurrency(value); 
                return IntegratedFiltering.defaultPredicate(value, filter, row);
               },

  },
  { columnName: 'FECHA_PROCESO',
     predicate: (value, filter, row) => {
                value = funciones.getTime(value, 0); 
                return IntegratedFiltering.defaultPredicate(value, filter, row);
               },

  },
  { columnName: 'FECHA_PAGO',
     predicate: (value, filter, row) => {
                value = value !== null ? funciones.getTime(value) : value; 
                return IntegratedFiltering.defaultPredicate(value, filter, row);
               },

  },
  { columnName: 'MONTO_ARANCEL',
     predicate: (value, filter, row) => {
                value = row.MONTO_SHOW.split(" ")[0] + " " + funciones.formatCurrency(value); 
                return IntegratedFiltering.defaultPredicate(value, filter, row);
               },

  },

];

const columnsFactDetail = [
  { name: 'DESCRIPCION_DTL', title: 'Descripción'},
  { name: 'TOTAL', title: 'Total'},
  { name: 'MONTO', title: 'Monto'},
  { name: 'MORA', title: 'Mora'},
  { name: 'BECA', title: 'Beca'},
  { name: 'CREDITO', title: 'Crédito'},
  { name: 'PAGAR', title: 'Pagar'},
  { name: 'FINAN', title: 'Financiado'},
];
const columnExtensionsDetail = [ 
  { columnName: 'ID_DETALLE', width: 0},
  { columnName: 'DESCRIPCION_DTL', width: widthTableDeta * 0.23},
  { columnName: 'TOTAL', width: widthTableDeta * 0.10, align: 'right'}, 
  { columnName: 'MONTO', width: widthTableDeta * 0.09, align: 'right'},        
  { columnName: 'MORA', width: widthTableDeta * 0.09, align: 'right'}, 
  { columnName: 'BECA', width: widthTableDeta * 0.09, align: 'right'},
  { columnName: 'CREDITO', width: widthTableDeta * 0.09, align: 'right'}, 
  { columnName: 'PAGAR', width: widthTableDeta * 0.09, align: 'right'}, 
  { columnName: 'FINAN', width: widthTableDeta * 0.10, align: 'right'}, 
];
const totalSummaryItemsDetail = [
  { columnName: "TOTAL", type: "sum" },    
  { columnName: "MONTO", type: "sum" },
  { columnName: "MORA", type: "sum" },
  { columnName: "BECA", type: "sum" },
  { columnName: "CREDITO", type: "sum" },
  { columnName: "PAGAR", type: "sum" }, 
  { columnName: "FINAN", type: "sum" },    
];

const RowId = row => row.ID_FACTURA;
const RowIdGest = row => row.ID_GESTION;
const RowIdDetail = row => row.ID_DETALLE;
const VirtualTable_cellComponent = (idRowSelected, handleOpenModalDate, permisoFacturar) => (props) => {  
    
  let style = { color: (props.row.ESTADO === "A" || props.row.ESTATUS === "A") ? "Red" :
                         props.row.ESTADO === "P" ? undefined :
                         props.row.ESTADO === "R" ? colores.color_inactive : 
                         "brown" }
  style = props.row.MONTO_ARANCEL !== undefined ? undefined : style;

  if (props.column.name === 'FECHA_PROCESO')
  {
    return (<Table.Cell style={style} {...props}>
             <div style={{ minWidth: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative' }} >
             <div style={{ paddingRight: 15 }}>{funciones.getTime(props.row.FECHA_PROCESO, 0)}</div>
             {(()=>{ 
              if (props.row.ID_FACTURA === idRowSelected && (props.row.ESTADO === "A" || props.row.ESTADO === "PE") && permisoFacturar)
              return ( 
                <Tooltip title='Ajustar fecha'>
                <IconButton style={{ position: 'absolute', right: 0 }} onClick={handleOpenModalDate} size="small">
                  <EventIcon />
                </IconButton>
                </Tooltip>)
             })()} 
            </div>
            </Table.Cell>);
  }

  if (props.column.name === 'FECHA_PAGO')
  {
    return (<Table.Cell style={style} {...props}>
            {props.row.FECHA_PAGO !== null ? funciones.getTime(props.row.FECHA_PAGO) : null}
            </Table.Cell>);
  }

  if (props.column.name === 'MONTO_TOTAL'){

    if (props.row.MONTO_SHOW !== undefined)
    return (<Table.Cell style={style} {...props}>
            {props.row.MONTO_SHOW.split(" ")[0] + " " + funciones.formatCurrency(props.row.MONTO_TOTAL)}
            </Table.Cell>);

    return (<Table.Cell style={style} {...props}>
            {props.row.MONTO_TOTAL_SHOW.split(" ")[0] + " " + funciones.formatCurrency(props.row.MONTO_TOTAL)}
            </Table.Cell>);

  }

  if (props.column.name === 'MONTO_ARANCEL'){
    return (<Table.Cell {...props}>
            {props.row.MONTO_SHOW.split(" ")[0] + " " + funciones.formatCurrency(props.row.MONTO_ARANCEL)}
           </Table.Cell>);
  }

  return (<Table.Cell style={style} {...props}/>);
    
}
const VirtualTableDetail_cellComponent = ({value, ...props}) => {  
  
  if (props.column.name !== "DESCRIPCION_DTL"){
    return (<Table.Cell value={props.row.SIMBOLO + " " + funciones.formatCurrency(value)} {...props} />);
  }

  return (<Table.Cell value={value} {...props}/>);
    
}
const TableSelectionCellComponent = (idRowSelected, handleClickOpciones, handleClickDetail, buttonMenuRef) => (props) =>{
  
  if (props.row.ID_FACTURA === idRowSelected)
  {
    return (<Table.StubCell style={{ paddingLeft: 2 }} {...props}>
             { props.row.ESTADO === "P" ? 
             <Tooltip title="Opciones de factura" PopperProps={{ style:{ zIndex: 400500 } }}>              
              <IconButton onClick={handleClickOpciones} disableRipple ref={buttonMenuRef} size="small">
                <MoreVertIcon />
              </IconButton>  
             </Tooltip>
              :
              <Tooltip title="Detalle" PopperProps={{ style:{ zIndex: 400500 } }}>              
              <IconButton onClick={handleClickDetail} size="small">
                <Crop54Icon />
              </IconButton>  
             </Tooltip>
             }
           </ Table.StubCell>);

  }

  return (<Table.StubCell {...props}/>);

}
const ItemComponent = (rows)=> ({children, ...props})=>{
  
  const pref = rows.length > 0 ? rows[0].MONTO_SHOW.split(" ")[0] : "";
  children = props.type === "count" ? children : pref + " " + funciones.formatCurrency(parseFloat(children));
  return (<TableSummaryRow.Item style={{ fontSize: 12 }} children={children} {...props} />);

}
const ItemComponentDetail = (rows)=> ({value, ...props})=>{
  
  const pref = rows.length > 0 ? rows[0].SIMBOLO : "";
  value = pref + " " + funciones.formatCurrency(parseFloat(value));
  
  return (<span style={{ fontSize: 12, color: "#000000" }}>
           <strong>{value}</strong>
          </span>);
   
}
const ColumnFixed_cellComponent = ({ showRightDivider, ...props}) => { 
  
  if (props.tableRow.key === "Symbol(filter)"){
    return (<TableFixedColumns.Cell {...props}>
              <div style={{ background: "white", height: "30px", width: "100%" }} />
             </TableFixedColumns.Cell>);
  }

  return (<TableFixedColumns.Cell 
            showRightDivider={false}
            style={{ backgroundColor: 'inherit' }}
            {...props} 
        />);
}
const TableSelectionDetailCellComponent = (idRowSelected, handleClickDelete, permisoEliminarGestion) => (props) =>{
  
  if (props.row.ID_DETALLE === idRowSelected && permisoEliminarGestion)
  {
    return (<Table.StubCell style={{ paddingLeft: 2 }} {...props}>
             <Tooltip title="Eliminar" PopperProps={{ style:{ zIndex: 400500 } }}>              
               <IconButton onClick={handleClickDelete} size="small">
                 <DeleteIcon />
               </IconButton>  
             </Tooltip> 
           </ Table.StubCell>);

  }

  return (<Table.StubCell {...props}/>);

}
const RenderOption = (option) => (
  <div style={{ display: "flex", flexDirection: "row", width: "100%", alignItems: "center" }}>
   <ListItemAvatar style={{ minWidth: 32 }}>
    <Avatar style={{ height: 23, width: 23 }}>
     <PersonIcon size="small"/>
    </Avatar>
   </ListItemAvatar>
  <div style={{ minWidth: "55px", color: "gray" }}>{option.CUENTA_ALUMNO}</ div>
  <div>{option.NOMBRE_COMPLETO}</div>
 </ div>
);

function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
    />
  );
}

NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default withStyles(styles) ( 
class App extends React.Component {
  
tablaRef = React.createRef();
tablaDialogRef = React.createRef();
dialogActionRef = React.createRef();
recibidoRef = React.createRef();
autorizacionRef = React.createRef();
buttonMenuRef = React.createRef();

  constructor (props) {
    super(props);
    this.l=props.l
    this.e=props.e
    this.i=props.i
    this.state = {
       isLoggin : undefined,
       heightTableMain: 0,
       loadingMain: false,
       rows: [],
       openBackDrop: false,
       optionAutocomplete: [],
       loadingClientes: true,
       valueAutoComplete: null,
       openAutoComplete: false,
       openModal: false,
       openModalConfirm: false,
       permisoFacturar: false,
       permisoEstadoCuenta: false,
       permisoEliminarGestion: false,
       permisoReversar: false,
       idRowSelected: null,
       rowsFact: [],
       heightTableFact: 0,
       loadingFact: false,
       openModalFact: false,
       datosSelectFormaPago: null,
       selectedFormaPago: '',
       datosSelectMoneda: null,
       selectedMoneda: '',
       factura: "",
       monto: "",
       valueAutorizacion: "",
       simboloMoneda: "",
       valueRecibido: "",
       valueCambio: "",
       openModalGest: false,
       heightTableGest: 0,
       loadingGest: false,
       rowsGest: [],
       selection: [],
       sumGestion: "0.00",
       rowsFactDetail: [],
       openModalFactDetail: false,
       loadingDetail: false,
       idRowDetailSelected: null,
       visibleModPago: false,
       disabledModPago: false,
       datosSelectModPago: null,
       selectedModPago: "",
       openModalDate: false,
       selectedDate: new Date(),
       openModalRpt: false,
       selectedDateIni: new Date(),
       selectedDateFin: new Date(),
       parametros: null,
       openMenu: false,
   };
   this.cuenta= null;
   this.botones = [
                  {icono: 'Add', toolt: 'Agregar curso',    nombre: 'Agregar'   ,escritura:true, onclick: this.addEvent,  display: 'auto'},
                  {icono: 'Edit', toolt: 'Modificar curso', nombre: 'Modificar' ,escritura:true, onclick: this.editEvent,  display:'auto'},
                  {icono: 'Delete', toolt: 'Eliminar curso', nombre: 'Eliminar' ,escritura:true, onclick: this.deleteEvent, color: colores.naranja, display: 'auto'},  
                 ];
   this.botones_facturar = [
    {icono: 'Check', toolt: '', nombre: 'Aceptar', onclick: this.handleOKFacturar, display:'auto'},
    {icono: 'Close', toolt: '', nombre: 'Cerrar', onclick: this.handleCloseFact, display:'auto', color: 'red'}
   ];
   this.botones_gestion = [
    {icono: 'Check', toolt: '', nombre: 'Aceptar', onclick: this.handleOKGestion, display:'auto'},
    {icono: 'Close', toolt: '', nombre: 'Cerrar', onclick: this.handleCloseGest, display:'auto', color: 'red'}
   ];
   this.botones_eliminar_dtl =[
    {icono: 'Check', toolt: '', nombre: 'Aceptar', onclick: this.handleOKDelete, display:'auto'},
    {icono: 'Close', toolt: '', nombre: 'Cerrar' ,onclick: this.handleCloseConfirm, display:'auto', color: 'red'},
   ]; 
   this.botones_fecha =[
    {icono: 'Check', toolt: '', nombre: 'Aceptar', onclick: this.okDateClick , display:'auto'},
    {icono: 'Close', toolt: '', nombre: 'Cerrar' ,onclick: this.handleCloseDate, display:'auto', color: 'red'},
   ];
   this.botones_reversar =[
    {icono: 'Check', toolt: '', nombre: 'Aceptar', onclick: this.okReverseClick , display:'auto'},
    {icono: 'Close', toolt: '', nombre: 'Cerrar' ,onclick: this.handleCloseConfirm, display:'auto', color: 'red'},
   ];
   this.botones_rpt = [
    {icono: 'Check', toolt: '', nombre: 'Aceptar', onclick: this.handleOKRpt, display:'auto'},
    {icono: 'Close', toolt: '', nombre: 'Cerrar', onclick: this.handleCloseRpt, display:'auto', color: 'red'}
   ];
   this.rowsFact=[];
   this.isFactured = false;
   this.sumGestionTmp = [];
   this.id_moneda_empresa = '';
}

onBlurAutoComplete = ()=>{

  if (this.state.openAutoComplete)
   this.setState({ openAutoComplete: false });    
      
}
    
onChangeInput = (e, value)=>{ 
    
  if (e === null || e.target.value === undefined)
  {
    if (this.state.openAutoComplete) 
      this.setState({ openAutoComplete: false });
               
    return;
  }
        
  if ((e.target.value.toString().trim().length < 3 || (this.state.valueAutoComplete !== null && value === this.state.valueAutoComplete.CUENTA_ALUMNO + ' | ' + this.state.valueAutoComplete.NOMBRE_COMPLETO)) && this.state.openAutoComplete)
    this.setState({ openAutoComplete: false });
  else if (e.target.value.toString().trim().length >= 3  && !this.state.openAutoComplete)
    this.setState({ openAutoComplete: true });
         
}
    
onChangeAutocomplete = (event, value) =>{
      
this.setState({ valueAutoComplete: value, 
                openAutoComplete: false, 
                permisoFacturar: false,
                permisoEstadoCuenta: false,
                datosSelectModPago: null,
                selectedModPago: "",
                rows: [],
                }, ()=>{
        
  if (value === null)
  {
    return;
  }
    
  this.obtener_facturas();   
      
});
    
}
  
filtersClientes = (value)=>{ 
  
  new Request
   .get(`${globales.ip}/facturacion/estudiantes/${value}`)
   .set({'authorization': 'Bearer ' + Auth.getToken() })
   .retry(0)
   .timeout({ response: 20000, deadline: 30000, }) 
   .end((err, res) => {
              
     if (err) { 
    
       if (err.toString().substr(0,16) === 'Error: Forbidden')
       {
                  
         window.location.reload();
         return;
                    
       }
        
      this.setState({ optionAutocomplete: [], openAutoComplete: false, loadingClientes: false }, ()=>{
        funciones.showToast('e', 'No hay conexión');
      });
                
      return;
     }
            
     const rows = JSON.parse(res.text);
     this.setState({ optionAutocomplete: rows, loadingClientes: false }); 
                 
       
});
    
}

onRefresh = ()=>{
  
 this.setState({ loadingClientes: true }, ()=>{ 
   this.filtersClientes('-');
 });
       
}

obtener_facturas = ()=>{

this.setState({ loadingMain: true }, ()=> { 

 this.cuenta = this.state.valueAutoComplete.CUENTA_ALUMNO;

 new Request
 .get(`${globales.ip}/facturacion/historial/${this.cuenta}/${tokenInfo.user}`) 
 .set({'authorization': 'Bearer ' + Auth.getToken() })
 .retry(1)
 .timeout({ response: 20000, deadline: 30000, })
 .end((err, res) => {
        
   if (err) { 

      if (err.toString().substr(0,16) === 'Error: Forbidden')
      {
            
        window.location.reload();
        return;
              
      }

      this.setState({ rows: [], loadingMain: false }, ()=>{ 
        funciones.showToast('e', 'No hay conexión');
      })
          
      return;
   }
      
   const rows = JSON.parse(res.text); 
   
   this.setState({ rows: (rows.length > 0 && rows[0].ID_FACTURA !== undefined) ? rows : [],
                   permisoFacturar: rows.length > 0 ? rows[0].PERMISO_FACTURAR : false,
                   permisoEstadoCuenta: rows.length > 0 ? rows[0].PERMISO_ESTADO_CUENTA : false,
                   permisoEliminarGestion: rows.length > 0 ? rows[0].PERMISO_ELIMINAR_GESTION : false,
                   permisoReversar: rows.length > 0 ? rows[0].PERMISO_REVERSAR : false,
                   loadingMain: false });    

   this.id_moneda_empresa = rows.length > 0 ? rows[0].ID_MONEDA_EMPRESA : '';  

   this.obtener_modalidades_pago();
   
 });

});

}

obtener_formas_pago = ()=>{

new Request
.get(`${globales.ip}/facturacion/formas_de_pago/${tokenInfo.user}`)
.set({'authorization': 'Bearer ' + Auth.getToken() })
.retry(1)
.timeout({ response: 15000, deadline: 30000, }) 
.end((err, res) => {
        
   if (err) { 

      if (err.toString().substr(0,16) === 'Error: Forbidden')
      {
            
        window.location.reload();
        return;
              
      }

      funciones.showToast('e', 'No hay conexión');
        
      return;
   }
      
   const rows = JSON.parse(res.text);

   if (rows.length > 0)
   {    
      const items = rows.map((item, i) =>{
        return <MenuItem value={item.ID_FORMA_PAGO} key={i}>{item.DESCRIPCION_FORMA_PAGO}</MenuItem> 
      });

      this.setState({ datosSelectFormaPago: items,
                      selectedFormaPago: rows[1].ID_FORMA_PAGO });
   }        
   
});

}

obtener_monedas = ()=>{

 new Request
  .get(`${globales.ip}/facturacion/monedas/${tokenInfo.user}`)
  .set({'authorization': 'Bearer ' + Auth.getToken() })
  .retry(1)
  .timeout({ response: 15000, deadline: 30000, }) 
  .end((err, res) => {
          
    if (err) { 
  
      if (err.toString().substr(0,16) === 'Error: Forbidden')
      {
              
        window.location.reload();
        return;
                
      }
  
     funciones.showToast('e', 'No hay conexión');
          
     return;
   }
        
   const rows = JSON.parse(res.text);
  
   if (rows.length > 0)
   {    
      const items = rows.map((item, i) =>{
        return <MenuItem value={item.ID_MONEDA} key={item.SIMBOLO}>{item.NOMBRE}</MenuItem> 
      });
  
      this.setState({ datosSelectMoneda: items, 
                      selectedMoneda: rows[0].ID_MONEDA });
   }        
     
});

}

obtener_modalidades_pago = ()=>{

new Request
 .get(`${globales.ip}/facturacion/modalidades_pago/${this.cuenta}/${tokenInfo.user}/${tokenInfo.plataforma}`)
 .set({'authorization': 'Bearer ' + Auth.getToken() })
 .retry(1)
 .timeout({ response: 15000, deadline: 30000, }) 
 .end((err, res) => {
          
   if (err) { 
  
    if (err.toString().substr(0,16) === 'Error: Forbidden')
    {
              
      window.location.reload();
      return;
                
    }
               
    funciones.showToast('e', 'No hay conexión');           
                
    return;
    
    }
        
    const modalidades = JSON.parse(res.text);          

    let items = modalidades.map((datos, i) =>{
                  return <MenuItem value={datos.MOD_PAGO_ID} key={i}>{datos.MOD_PAGO_DESCRIPCION}</MenuItem> 
                 });

    const modalidadSel = modalidades.find(x => x.ID_MODALIDAD_CLIENTE);

    this.setState({ datosSelectModPago: items, 
                    selectedModPago: modalidadSel !== undefined ? modalidadSel.MOD_PAGO_ID : "" });
     
 });

}

handleRowClick = (idRow) => event => {
  this.setState({ idRowSelected: idRow });
}

handleRowDetailClick = (idRow) => event => {
 this.setState({ idRowDetailSelected: idRow });
}

handleClickFacturar = ()=>{

if (funciones.isEmpty(this.state.selectedModPago)){
 funciones.showToast("w", "Es necesario seleccionar una modalidad de pago"); 
 return;
}  

const rows = this.state.rows.filter(x => x.ESTATUS === 'Activa');
const factura = rows.length > 0 ? rows[rows.length - 1].ID_FACTURA : 0;

 this.setState({ rowsFact: [], 
                 factura,
                 monto: " ", 
                 valueRecibido: " ",
                 textbackdrop: "Procesando...",
                 openModalFact: true }, ()=>{
    
  if (!funciones.isEmpty(this.state.datosSelectFormaPago) && this.state.datosSelectFormaPago.length > 1)
  this.handleChangeSelect({ target: { name: "FormaPago", value: this.state.datosSelectFormaPago[1].props.value }});
                 
  if (!funciones.isEmpty(this.state.datosSelectMoneda))
  this.handleChangeSelect({ target: { name: "Moneda", value: this.id_moneda_empresa, disabledChanceCurrency: true }});

});
}

handleClose = ()=>{
  this.setState({ openModal: false });
}

handleCloseFact = ()=>{
  this.setState({ openModalFact: false });
}

onEnteringFact = ()=>{

this.setState({ loadingFact: true }, ()=>{

  new Request
  .get(`${globales.ip}/facturacion/facturas_activas/${this.cuenta}/${tokenInfo.user}`)
  .set({'authorization': 'Bearer ' + Auth.getToken() })
  .retry(1)
  .timeout({ response: 15000, deadline: 30000, }) 
  .end((err, res) => {
          
     if (err) { 
  
        if (err.toString().substr(0,16) === 'Error: Forbidden')
        {
              
          window.location.reload();
          return;
                
        }
  
        this.setState({ loadingFact: false }, ()=>{
          funciones.showToast('e', 'No hay conexión');
        });
            
        return;
     }
        
     this.rowsFact = JSON.parse(res.text);

     if (this.rowsFact.length > 0 && this.rowsFact[0].RESP !== undefined){
        funciones.showToast("w", this.rowsFact[0].RESP);
        this.rowsFact=[];
        this.setState({ loadingFact: false });
        return;
     }

     const rowsFact = this.rowsFact.filter(x => x.ID_MONEDA === this.state.selectedMoneda);    
     
     this.setState({ rowsFact, 
                     monto: this.getFormatMonto(rowsFact),
                     loadingFact: false }, ()=>{
                      
       if (!funciones.isEmpty(this.state.datosSelectFormaPago) && this.state.datosSelectFormaPago.length > 1)
        this.handleChangeSelect({ target: { name: "FormaPago", value: this.state.datosSelectFormaPago[1].props.value }});             

    });                  
     
  });

});

}

getFormatMonto = (rows)=>{

let monto = 0;
let moneda = null;

rows.filter(x => x.ESTATUS === "A" || x.ESTATUS === "Activa").map((item)=>{ 
  if (moneda === null)
    moneda = item.MONTO_SHOW !== undefined ? item.MONTO_SHOW.split(" ")[0] : item.MONTO_TOTAL_SHOW.split(" ")[0];

    monto = monto + item.MONTO_TOTAL;
    return item;
});

return (moneda === null ? "" : moneda + " ") + funciones.formatCurrency(monto);

}

onEntering = ()=>{

this.setState({ heightTableFact: funciones.getHeightTableDialog(movil, this.tablaDialogRef, this.dialogActionRef, !movil ? 7 : 5) });

}

handleInfoFact = ()=>{

this.setState({ openModal: true });

}

handleOKFacturar = ()=>{

 if (this.state.rowsFact.length === 0){
   funciones.showToast("w", "No hay información necesaria para facturar");
   return;
 }

 if (funciones.isEmpty(this.state.valueAutorizacion)){
   funciones.showToast("w", "Ingrese el número de autorización");
   this.autorizacionRef.current.focus();
   return;
  }
 
 if (funciones.isEmpty(this.recibidoRef.current.value) || parseFloat(this.recibidoRef.current.value.replace(",","")) < parseFloat(this.state.monto.split(" ")[1].replace(",",""))){
  funciones.showToast("w", "La cantidad recibida no es correcta");
  this.recibidoRef.current.focus();
  return;
 }
 
 this.setState({ openBackDrop: true }, ()=>{ 
   
   new Request
    .post(`${globales.ip}/facturacion`)
    .set({'authorization': 'Bearer ' + Auth.getToken() })
    .set('Content-Type', 'application/json')
    .send({ recibo: String(this.state.valueAutorizacion), 
            banco: "USPS", 
            cuenta_alumno: this.cuenta,
            monto: parseFloat(this.state.monto.split(" ")[1].replace(",", "")),
            id_moneda: this.state.selectedMoneda,
            id_forma_pago:this.state.selectedFormaPago,
            ad_usuario: tokenInfo.user })
    .retry(0)
    .timeout({ response: 50000, deadline: 60000, }) 
    .end((err, res) => {
                  
      if (err) { 
          
        if (err.toString().substr(0,16) === 'Error: Forbidden')
        {
                      
          window.location.reload();
          return;
                       
        }
          
        this.setState({ openBackDrop: false }, ()=>{ 
          funciones.showToast('e', 'No hay conexión'); 
        });       
            
        return;
      }
                
      const rows = JSON.parse(res.text); 
             
      if (rows[0].RESP === undefined)
      {       

        funciones.crearReciboPdf(this.state.factura, 
                                 funciones.getTime(rows[0].FECHA_PAGO), 
                                 funciones.getTime(rows[0].FECHA_PAGO, 0),
                                 rows[0].REFERENCIA1,
                                 rows[0].CUENTA_ALUMNO,
                                 rows[0].NOMBRE_COMPLETO,
                                 rows[0].DESCRIPCION_PLAN, 
                                 rows,
                                 this.state.monto,
                                 this.state.simboloMoneda + " " + funciones.formatCurrency(parseFloat(this.state.valueRecibido.replace(",", ""))),
                                 this.state.simboloMoneda + " " + this.state.valueCambio,
                                 tokenInfo.user,
                                 movil, 
                                 this.callbackPrintDialog);  
                                 this.obtener_facturas();  
                                 
      }
      else      
        this.setState({ openBackDrop: false }, ()=>{ 
          funciones.showToast('w', rows[0].RESP);
        });             
            
  });

 });

}

handleChangeSelect = (event)=>{

const {name, value, disabledChanceCurrency} = event.target;
const id_moneda_current = this.state.selectedMoneda;

if (name === "ModPago")
 this.modPago_old = this.state.selectedModPago;

this.setState({ ["selected"+name]: value }, ()=>{

  if (name === "Moneda"){

    let simbol;
    let id_moneda;
    let moneda;
    const items = this.state.datosSelectMoneda;
    Object.keys(items).map((key)=>{
      if (items[key].props.value === value){
       simbol = items[key].key;
       id_moneda = items[key].props.value;
       moneda = items[key].props.children;
      }
      return key;
    });
    

    if (disabledChanceCurrency){
      this.setState({ simboloMoneda: simbol });
      return;
    }
   

    if (this.rowsFact.length === 0){
      funciones.showToast("w", "No hay facturas activas");
      this.handleChangeSelect({ target: { name: "Moneda", value: id_moneda_current, disabledChanceCurrency: true }});
      return;
    }

    const rowsFact = this.rowsFact.filter(x => x.ID_MONEDA === id_moneda);

    if (rowsFact.length === 0){

     funciones.showToast("w", "No hay tasa de cambio para " + moneda);
     this.handleChangeSelect({ target: { name: "Moneda", value: id_moneda_current, disabledChanceCurrency: true }});
     return;
    }

    this.setState({ simboloMoneda: simbol, 
                    monto: this.getFormatMonto(rowsFact),
                    rowsFact }, ()=>{
                      this.handleChangeSelect({ target: { name: "FormaPago", value: this.state.selectedFormaPago }});
                    });

  }

  if (name === "FormaPago"){

    if (value === 0)
      this.setState({ valueAutorizacion: this.state.factura, valueRecibido: "", valueCambio: "" }, ()=>{
        this.recibidoRef.current.focus();
      });
    else
      this.setState({ valueAutorizacion: "", valueRecibido: this.state.monto !== "0.00" ? this.state.monto.split(" ")[1] : "", valueCambio: "0.00" }, ()=>{
        this.autorizacionRef.current.focus();
      });    

  }

  if (name === "ModPago"){
    this.actualizar_mod_pago();
  }

});

}

onChangeTextfield = (event)=>{
   
  const { id, value } = event.target;

  this.setState({ ["value"+id]: value }, ()=>{
    if (id === "Recibido"){
      let monto = this.state.monto.split(" ")[1];
      if (monto === undefined) return;

      const cambio = value - parseFloat(monto.replace(",", ""));
      this.setState({ valueCambio: funciones.formatCurrency(cambio) });
      
    }
     
  });
}

onChangeTextfield1 = (event)=>{
  
  const {  value } = event.target;
   
   if(this.state.selectedFormaPago === 0)
   {
   let monto = this.state.monto.split(" ")[1];
   if (monto === undefined) return;
  
   let valueSeparator =parseFloat(value.replace(/[^0-9]/g, ''));
   valueSeparator =  (Number(valueSeparator) / 100).toFixed(2); //Con decimales
 
   /*let valueSeparator =parseFloat(value);*/ //Sin decimales
  
   const cambio = valueSeparator - parseFloat(monto.replace(",", ""));
    this.setState({ valueCambio:funciones.formatCurrency(cambio) ,valueRecibido: valueSeparator});
 
   }
 
 }

callbackPrintDialog = ()=>{

setTimeout(() => {
  this.setState({ openBackDrop: false }, ()=>{
   if (this.state.openModalFact){
    this.isFactured = true; 
    this.handleCloseFact();
   }
   
   if (movil)
    funciones.showToast("s", "El proceso finalizó con éxito");

  });
}, 1000);  

setTimeout(() => { 
  if (movil){ 
    this.isFactured = false;
    this.obtener_facturas();
  }
}, 1800);

}

handleClickAddGestion = ()=>{

this.sumGestionTmp = [];
this.setState({ rowsGest: [], 
                selection: [],
                sumGestion: "0.00",
                textbackdrop: "Procesando...",
                openModalGest: true });

}

onEnteringGest = ()=>{

this.setState({ heightTableGest: funciones.getHeightTableDialog(movil, this.tablaDialogRef, this.dialogActionRef, !movil ? 7 : 5), loadingGest: true }, ()=>{
  
 new Request
 .get(`${globales.ip}/facturacion/transacciones/${this.cuenta}/${tokenInfo.user}/${tokenInfo.sucursal}`)
 .set({'authorization': 'Bearer ' + Auth.getToken() })
 .retry(1)
 .timeout({ response: 15000, deadline: 30000, }) 
 .end((err, res) => {
         
    if (err) { 
 
       if (err.toString().substr(0,16) === 'Error: Forbidden')
       {
             
         window.location.reload();
         return;
               
       }
 
       this.setState({ loadingGest: false }, ()=>{ 
         funciones.showToast('e', 'No hay conexión');
       });
   
       return;
    }
       
    const rows = JSON.parse(res.text);
 
    this.setState({ rowsGest: rows, 
                    loadingGest: false });           
    
  });


});
}

handleCloseGest = ()=>{
  this.setState({ openModalGest: false });
}

changeSelection = selection =>{  
 
 const idRow = funciones.getIdRowChecking(selection, this.state.selection); 
 const actionCheck = selection.length > this.state.selection.length ? 1 : 0;
 const row = this.state.rowsGest.find(x => x.ID_GESTION === idRow);
 const {ID_MONEDA, MONTO_ARANCEL, MONTO_SHOW} = row;
 let sumGestion= null;
 
 if (this.sumGestionTmp.find(x => x.ID_MONEDA === ID_MONEDA) !== undefined)
  this.sumGestionTmp.map((item)=>{
    if (item.ID_MONEDA === ID_MONEDA)
      item.MONTO_ARANCEL = Boolean(actionCheck) ? item.MONTO_ARANCEL + MONTO_ARANCEL
                                                : item.MONTO_ARANCEL - MONTO_ARANCEL;
      
      item.ID_MONEDA =  item.MONTO_ARANCEL > 0 ? item.ID_MONEDA : null;

    return item;
  });
 else
   this.sumGestionTmp.push({ ID_MONEDA, MONEDA: MONTO_SHOW.split(" ")[0], MONTO_ARANCEL });
   
  this.sumGestionTmp = this.sumGestionTmp.filter(x => x.ID_MONEDA !== null);
  if (this.sumGestionTmp.length > 0)   
  this.sumGestionTmp.map((item)=>{
    sumGestion = (sumGestion === null ? "" : sumGestion) + (sumGestion !== null ? " | " : "") + item.MONEDA + " " + funciones.formatCurrency(item.MONTO_ARANCEL);
    return item;
  });
  else
  sumGestion = "0.00";
  
 this.setState({ selection, sumGestion });   

}

handleOKGestion = ()=>{

if (this.state.selection.length === 0){
  funciones.showToast("w","Ninguna gestión seleccionada");
  return;
}

this.setState({ openBackDrop: true }, ()=>{

 let transacciones = "";
 this.state.selection.map((item, index)=>{ 
   transacciones += ((index + 1) < this.state.selection.length ? String(item) + "," : String(item));
   return item;
 });
 
 new Request
  .post(`${globales.ip}/facturacion/transacciones`)
  .set({'authorization': 'Bearer ' + Auth.getToken() })
  .set('Content-Type', 'application/json')
  .send({ cuenta_alumno: this.cuenta, 
          id_sucursal: tokenInfo.sucursal,
          transacciones, 
          ad_usuario: tokenInfo.user })
  .retry(0)
  .timeout({ response: 30000, deadline: 30000, }) 
  .end((err, res) => {
                  
     if (err) { 
          
       if (err.toString().substr(0,16) === 'Error: Forbidden')
       {
                      
         window.location.reload();
         return;
                        
       }
          
        this.setState({ openBackDrop: false }, ()=>{ 
          funciones.showToast('e', 'No hay conexión'); 
        });      
            
        return;
      }
                
      const rows = JSON.parse(res.text);          
         
      if (rows[0].RESP === undefined)
      {       
        this.setState({ rows, openBackDrop: false }, ()=> {                 
          funciones.showToast('s', 'El proceso ha finalizado con éxito'); 
          this.handleCloseGest();
        });     

      }
      else
      {
        this.setState({ openBackDrop: false }, ()=>{
          funciones.showToast('w', rows[0].RESP);
        });
                 
      }
            
  });

});

}

handleClickDetail = ()=>{

this.modPago_old = null;
this.setState({ rowsFactDetail: [],
                heightTableFact: 0,
                visibleModPago: false,
                openModalFactDetail: true });

}

handleCloseDetail = ()=>{
  this.setState({ openModalFactDetail: false }, ()=>{
    if (this.modPago_old !== null)
     this.obtener_facturas();
  });
}

onEnteringDetail = ()=>{
 
 const rowSelected = this.state.rows.find(x => x.ID_FACTURA === this.state.idRowSelected); 
 this.setState({ heightTableFact: funciones.getHeightTableDialog(movil, this.tablaDialogRef, this.dialogActionRef, !movil ? 7 : 5), 
                 visibleModPago: (rowSelected.ID_TIPO_TRANSACCION === 5 || rowSelected.ID_TIPO_TRANSACCION === 9) ? true : false,
                 disabledModPago: !this.state.permisoFacturar || (rowSelected.ESTADO !== "A" && rowSelected.ESTADO !== "PE"),
                 loadingDetail: true }, ()=>{

  new Request
   .get(`${globales.ip}/facturacion/factura/detalle/${this.state.idRowSelected}`)
   .set({'authorization': 'Bearer ' + Auth.getToken() })
   .retry(1)
   .timeout({ response: 15000, deadline: 30000, }) 
   .end((err, res) => {
                          
     if (err) { 
                  
      if (err.toString().substr(0,16) === 'Error: Forbidden')
      {
                              
        window.location.reload();
        return;
                                
      }
                 
      this.setState({ loadingDetail: false }, ()=>{ 
        funciones.showToast('e', 'No hay conexión');
      });
                    
      return;
     }
                        
     const rows = JSON.parse(res.text); 
                  
     this.setState({ rowsFactDetail: rows, 
                     loadingDetail: false });        
                     
    });
    
 });
  
}

handleClickDeleteDetail = ()=>{
  this.setState({ titleModal: "Detalle",
                  textModal: "¿Desea eliminar el detalle seleccionado?",
                  textbackdrop: "Eliminando...",
                  openModalConfirm: true });
}

handleCloseConfirm = ()=>{
  this.setState({ openModalConfirm: false });
}

handleOKDelete = ()=>{
  
this.setState({ openBackDrop: true, 
                openModalConfirm: false }, ()=>{

new Request
.post(`${globales.ip}/facturacion/factura/detalle/remover`)
.set({'authorization': 'Bearer ' + Auth.getToken() })
.set('Content-Type', 'application/json')
.send({ id_detalle: this.state.idRowDetailSelected,
        ad_usuario: tokenInfo.user })
.retry(0)
.timeout({ response: 15000, deadline: 30000, }) 
.end((err, res) => {
        
  if (err) { 

    if (err.toString().substr(0,16) === 'Error: Forbidden')
    {
            
      window.location.reload();
      return;
              
    }

    this.setState({ openBackDrop: false }, ()=>{ 
      funciones.showToast('e', 'No hay conexión'); 
    });
      
    return;
  }
      
  const rows = JSON.parse(res.text);

  if (rows[0].RESP === undefined)
  { 
    const rowsFactDetail = this.state.rowsFactDetail.filter(x => x.ID_DETALLE !== this.state.idRowDetailSelected);
    
    this.setState({ rowsFactDetail, openBackDrop: false }, ()=> {                 
      funciones.showToast('s', 'Se ha eliminado el detalle especificado'); 
      
      if (rowsFactDetail.length > 0)
         this.setState({ rows });
      else
         this.setState({ rows, openModalFactDetail: false });
      
     });   
  }
  else
  {
    this.setState({ openBackDrop: false }, ()=> { 
      funciones.showToast('w', rows[0].RESP);  
    });           
  }            
  
});

});

}

actualizar_mod_pago = ()=>{
  
this.setState({ loadingDetail: true }, ()=>{
  
new Request
 .post(`${globales.ip}/facturacion/modalidades_pago/modalidad`)
 .set({'authorization': 'Bearer ' + Auth.getToken() })
 .set('Content-Type', 'application/json')
 .send({ id_modalidad: this.state.selectedModPago, 
         id_factura: this.state.idRowSelected,
         ad_usuario: tokenInfo.user })
 .retry(0)
 .timeout({ response: 15000, deadline: 30000, }) 
 .end((err, res) => {
          
    if (err) { 
  
      if (err.toString().substr(0,16) === 'Error: Forbidden')
      {
              
        window.location.reload();
        return;
                
      }
  
      this.setState({ selectedModPago: this.modPago_old, 
                      loadingDetail: false }, ()=>{ 
        funciones.showToast('e', 'No hay conexión'); 
      });
        
      return;
    }
        
    const rows = JSON.parse(res.text);
  
    if (rows[0].RESP === undefined)
    {       
      this.setState({ rowsFactDetail: rows, loadingDetail: false });     
    }
    else
    {
      this.setState({ selectedModPago: this.modPago_old, 
                      loadingDetail: false }, ()=>{
        funciones.showToast('w', rows[0].RESP); 
      });
    }
                
});
  

});

}

handleOpenModalDate = ()=> {
  const date = this.state.rows.find(x => x.ID_FACTURA === this.state.idRowSelected).FECHA_PROCESO;

  this.setState({ selectedDate: new Date(date.substr(0,19)), 
                  textbackdrop: "Configurando fecha...",
                  openModalDate: true });
}

handleCloseDate = ()=>{
  this.setState({ openModalDate: false });
}

handleDateChange = (date)=>{
  
this.setState({ selectedDate: date });
  
}

handleDateChangeIni = (date)=>{
  this.setState({ selectedDateIni: date });
}

handleDateChangeFin = (date)=>{
  this.setState({ selectedDateFin: date });
}

okDateClick = ()=>{

this.setState({ openBackDrop: true }, ()=>{

const newDate = this.state.selectedDate.getFullYear() + '-' + 
                (parseInt(this.state.selectedDate.getMonth()) + 1).toString().padStart(2, '0') + '-' + 
                this.state.selectedDate.getDate().toString().padStart(2, '0') + "T00:00:00.000";

new Request
 .post(`${globales.ip}/facturacion/factura/fecha-proceso`)
 .set({'authorization': 'Bearer ' + Auth.getToken() })
 .set('Content-Type', 'application/json')
 .send({ fecha_nueva: newDate, 
         id_factura: this.state.idRowSelected, 
         ad_usuario: tokenInfo.user })
 .retry(0)
 .timeout({ response: 15000, deadline: 30000, }) 
 .end((err, res) => {
                        
    if (err) { 
                
     if (err.toString().substr(0,16) === 'Error: Forbidden')
     {
                            
       window.location.reload();
       return;
                              
     }
                
     this.setState({ openBackDrop: false }, ()=>{ 
       funciones.showToast('e', 'No hay conexión'); 
     });               
                 
     return;
    }
                      
    const rows = JSON.parse(res.text);
                
    if (rows[0].RESP === undefined)
    {       
      this.setState({ rows, openBackDrop: false }, ()=> {                 
        funciones.showToast('s', 'Se ha actualizado la fecha de proceso');
        this.handleCloseDate();
      });     
      
    }
    else
    {
      this.setState({ openBackDrop: false }, ()=> {
        funciones.showToast('w', rows[0].RESP);
      });
    }
                  
  });

});

}

handleReverseClick = ()=>{
  this.setState({ titleModal: "Factura",
                  textModal: "¿Desea reversar la factura seleccionada?",
                  textbackdrop: "Reversando...",
                  openModalConfirm: true });
}

okReverseClick = ()=>{

this.setState({ openBackDrop: true, openModalConfirm: false }, ()=>{

const referencia = this.state.rows.find(x => x.ID_FACTURA === this.state.idRowSelected).REFERENCIA1;

new Request
 .post(`${globales.ip}/facturacion/factura/reversion`)
 .set({'authorization': 'Bearer ' + Auth.getToken() })
 .set('Content-Type', 'application/json')
 .send({ referencia, 
         cuenta_alumno: this.cuenta, 
         ad_usuario: tokenInfo.user })
 .retry(0)
 .timeout({ response: 15000, deadline: 30000, }) 
 .end((err, res) => {
          
   if (err) { 
  
    if (err.toString().substr(0,16) === 'Error: Forbidden')
    {
              
      window.location.reload();
      return;
              
    }
  
    this.setState({ openBackDrop: false }, ()=>{ 
      funciones.showToast('e', 'No hay conexión'); 
    });
           
    return;
  }
        
  const rows = JSON.parse(res.text);
  
  if (rows[0].RESP === undefined)
  {       
    this.setState({ rows, openBackDrop: false }, ()=> {                 
      funciones.showToast('s', 'Se ha reversado la factura'); 
    });     

  }
  else
  {
    this.setState({ openBackDrop: false }, ()=>{ 
      funciones.showToast('w', rows[0].RESP);
    });        
  }              
    
 });

});

}

handleReprintClick = ()=>{

const referencia1 = this.state.rows.find(x => x.ID_FACTURA === this.state.idRowSelected).REFERENCIA1;

if (funciones.isEmpty(referencia1)){
  funciones.showToast("w", "La factura no tiene valor de referencia");
  return;
}

this.setState({ textbackdrop: "Procesando...",
                openBackDrop: true }, ()=>{
 
new Request
.get(`${globales.ip}/facturacion/factura/recibo/${this.cuenta}/${referencia1}`)
.set({'authorization': 'Bearer ' + Auth.getToken() })
.retry(1)
.timeout({ response: 15000, deadline: 30000, }) 
.end((err, res) => {
        
   if (err) { 

      if (err.toString().substr(0,16) === 'Error: Forbidden')
      {
            
        window.location.reload();
        return;
              
      }

      this.setState({ openBackDrop: false }, ()=>{ 
       funciones.showToast('e', 'No hay conexión');
      });
  
      return;
   }
      
   const rows = JSON.parse(res.text);

   let monto = 0;
   rows.map((item)=>{
     monto += item.MONTO_TOTAL; 
     return item;
   });
   
   funciones.crearReciboPdf(this.state.factura, 
                            funciones.getTime(rows[0].FECHA_PAGO), 
                            funciones.getTime(new Date(new Date()+" UTC").toISOString().slice(0, 10) + " 00:00:00", 0),
                            rows[0].REFERENCIA1,
                            rows[0].CUENTA_ALUMNO,
                            rows[0].NOMBRE_COMPLETO,
                            rows[0].DESCRIPCION_PLAN, 
                            rows,
                            rows[0].Simbolo + funciones.formatCurrency(monto),
                            rows[0].Simbolo + funciones.formatCurrency(monto), 
                            rows[0].Simbolo + "0.00", 
                            tokenInfo.user,
                            movil, 
                            this.callbackPrintDialog);              
   
});

});

}

handleClickRpt = ()=>{
  this.setState({ parametros: null, 
                  openModalRpt: true });
}

handleClickRpt_detalle =async ()=>{
  if(this.state.idRowSelected!==null){
    await Promise.resolve(this.setState({ parametros: this.state.idRowSelected.toString() }));
    document.getElementById("BTFAC-DET").click();
  }
  else{
    funciones.showToast('i','Debe seleccionar una factura');
  }
}


handleCloseRpt = ()=>{
  this.setState({ openModalRpt: false });
}

handleOKRpt = async ()=>{

const fecha_ini = funciones.getDateSelect(new Date(this.state.selectedDateIni + " UTC"));
const fecha_fin = funciones.getDateSelect(new Date(this.state.selectedDateFin + " UTC"));

if (fecha_ini > fecha_fin){
  funciones.showToast("w", "La fecha de inicio no debe ser mayor a la final");
  return;
}

await Promise.resolve(this.setState({ parametros: this.cuenta + "," + fecha_ini + "," + fecha_fin }));
document.getElementById("BTFAC-EC").click();

}

handleOpenMenuTable = (event) => {
  
  const rowSelected = this.state.rows.find(x => x.ID_FACTURA === this.state.idRowSelected);
    
  this.setState({ disabledOptionMenuRev: rowSelected.ESTADO !== "P" ? true : false,
                  disabledOptionMenuImp: rowSelected.ESTADO !== "P" ? true : false, 
                  openMenu: true }); 
  
}

handleCloseMenuTable = (option) => (event)=>{

this.setState({ openMenu: false }, ()=>{

  switch (option) {
    case 1:
      this.handleClickDetail();                  
      break;
    case 2: 
      this.handleReverseClick();
      break;
    case 3:
      this.handleReprintClick();    
      break;
    default:
     break;
  }

});

}

componentDidMount() { 

 tokenInfo = Auth.getProfile(); //Token decodificado

 this.setState({ isLoggin: tokenInfo.plataforma !== undefined ? true : false }, ()=>{

  if (tokenInfo.plataforma === 1) // Usuario Admin
  {
    this.cuenta= null;
    this.filtersClientes('-');
  }
     
  this.setState({ heightTableMain: funciones.getHeightTableMain(movil, this).heightTable }, ()=>{ 
    if (!movil)
    document.getElementById('est_fac').focus(); 
  }); 
    this.obtener_formas_pago();
    this.obtener_monedas();
 }); 
  
window.onfocus = ()=>{
  if (this.isFactured && !movil){
    this.isFactured = false;
    funciones.showToast("s", "El proceso finalizó con éxito");
    this.obtener_facturas();
  }
}

}

componentWillUnmount() { 
  window.onfocus= undefined;
}

render() {
const { classes } = this.props;

  if (this.state.isLoggin === true)
  {
  return (
    
    <React.Fragment>
      <Paper className="Paper-main" square>
          {
            (() => {
              
            if (tokenInfo.plataforma === 1) //Si es Usuario Admin
             {
              
              return (
                <React.Fragment>
                 <div className={classes.container}>    
                   <Autocomplete
                      id="est_fac"
                      options={this.state.optionAutocomplete}
                      getOptionLabel={(option) => option.CUENTA_ALUMNO + ' - ' + option.NOMBRE_COMPLETO}
                      style={{ width: movil ? '100%' : '430px' }}
                      renderInput={(params) => <TextField {...params} 
                                                  label="Estudiante"
                                                  variant="outlined"
                                                  onBlur={this.onBlurAutoComplete}                                                                                                                         
                                                  InputProps={{
                                                             ...params.InputProps,
                                                              endAdornment: (
                                                               <React.Fragment>
                                                                {this.state.loadingClientes ? 
                                                                 <Fade in style={{
                                                                  transitionDelay: '1000ms',
                                                                  }} unmountOnExit>
                                                                   <CircularProgress size={18}/> 
                                                                 </Fade>
                                                                 : 
                                                                 this.state.valueAutoComplete === null ?
                                                                  <Tooltip title="Actualizar lista" placement="top">
                                                                  <IconButton style={{ width: 23, height: 23 }} onClick={this.onRefresh}>
                                                                    <RefreshIcon color="primary"/>
                                                                  </IconButton>
                                                                  </Tooltip>
                                                                 : null
                                                                }
                                                                {params.InputProps.endAdornment}
                                                                </React.Fragment>
                                                                 ),
                                                            }}
                                                            fullWidth
                                                            />}
                        renderOption={RenderOption}                                 
                        onChange={this.onChangeAutocomplete}
                        open={this.state.openAutoComplete}
                        loading={this.state.loadingClientes}
                        ListboxComponent={virtual.ListboxComponent}                            
                        value={this.state.valueAutoComplete} 
                        className={classes.textField}                            
                        disableClearable={this.state.loadingMain}                            
                        onInputChange={this.onChangeInput}
                        popupIcon={null}
                        PaperComponent={(props)=>(<Paper elevation={8} {...props} />)}                                                                              
                         />
                       <Divider orientation="vertical" flexItem style={{ margin: !movil ? "12px 20px" : "5px 0px" }}/>
                       <div style={{ margin: movil ? "8px 5px" : undefined }}>
                       <Button variant="contained" 
                               color="primary"
                               style={{ textTransform: "none" }}
                               startIcon={<CheckIcon fontSize="small" />}
                               onClick={this.handleClickFacturar}
                               disabled={funciones.isEmpty(this.state.valueAutoComplete) || !this.state.permisoFacturar}
                         >
                         {!movil ? "Efectuar pago" : "Efec. pago"}
                        </Button> 
                        <Button variant="contained" 
                                color="primary"
                                style={{ textTransform: "none", marginLeft: 15 }}
                                startIcon={<AddIcon fontSize="small" />}
                                onClick={this.handleClickAddGestion}
                                disabled={funciones.isEmpty(this.state.valueAutoComplete) || !this.state.permisoFacturar}
                         >
                        {!movil ? "Agregar gestión" : "Agr. gestión"}
                        </Button>   
                        <Button variant="contained" 
                                color="primary"
                                style={{ textTransform: "none", marginLeft: 15 }}
                                startIcon={<PrintIcon fontSize="small" />}
                                onClick={this.handleClickRpt}
                                disabled={funciones.isEmpty(this.state.valueAutoComplete) || !this.state.permisoEstadoCuenta}
                         >
                        {!movil ? "Estado de cuenta" : "Est. de cuenta"}
                        </Button> 
                        <Button variant="contained" 
                                color="primary"
                                style={{ textTransform: "none", marginLeft: 15 }}
                                startIcon={<PrintIcon fontSize="small" />}
                                onClick={this.handleClickRpt_detalle}
                                disabled={funciones.isEmpty(this.state.valueAutoComplete) || !this.state.permisoEstadoCuenta}
                         >
                          {!movil ? "Detalle de pago" : "Det. de pago"}
                        </Button>
                       </ div>                        
                   </div>
                 <div ref={this.tablaRef} style={{ marginLeft: !movil ? globales.tabla.marginleft : globales.tabla.marginleft_movil, marginRight: !movil ? globales.tabla.marginright : globales.tabla.marginright_movil }}>
                 <CustomTable 
                   Columns={columns} 
                   Rows={this.state.rows}                      
                   TableColumnExtensions={columnExtensions}
                   columnWidths={columnExtensions}
                   getRowId={RowId}
                   VirtualTable_cellComponent={VirtualTable_cellComponent(this.state.idRowSelected, this.handleOpenModalDate, this.state.permisoFacturar)}
                   height={this.state.heightTableMain} 
                   loading= {this.state.loadingMain}
                   enabledFilterRows
                   showSelectionColumn
                   rowSelected={this.state.idRowSelected}
                   rowClick={this.handleRowClick}
                   FilteringColumnExtensions={settingFilter}
                   leftColumnsFixed={[TableSelection.COLUMN_TYPE]}
                   columnFixedCellComponent={ColumnFixed_cellComponent}              
                   tableSelectionCellComponent= {TableSelectionCellComponent(this.state.idRowSelected, this.handleOpenMenuTable, this.handleClickDetail, this.buttonMenuRef)}         
                 />                  
                 </div>
                <Dialog open= {this.state.openModal}                            
                        TransitionProps={{ onEntering: this.onEntering }} 
                        classes={{ paper: classes.paper }}
                        fullScreen={movil}
                        hideBackdrop>
                 <DialogTitle><Typography component='span' variant='subtitle2'>Facturas activas</Typography>
                    <IconButton className={classes.closeButton} onClick={this.handleClose} size="small">
                      <CloseIcon fontSize="small" />
                    </IconButton>
                 </DialogTitle>
                 <DialogContent>
                 <div ref={this.tablaDialogRef} className="disableTouchOptions">  
                  <CustomTable 
                    Columns={columnsFact} 
                    Rows={this.state.rowsFact}
                    height={this.state.heightTableFact}
                    loading={this.state.loadingFact} 
                    TableColumnExtensions={columnExtensionsFact}
                    columnWidths={columnExtensionsFact}
                    VirtualTable_cellComponent={VirtualTable_cellComponent(null, null, null)}
                    totalItems={totalSummaryItems}
                    summaryRowMessages={{ count: 'Cantidad', sum: 'Total' }}
                    totalItemComponent={ItemComponent(this.state.rowsFact)}
                   />                    
                  </div>
                 </ DialogContent>
                 <DialogActions ref={this.dialogActionRef} />
                </Dialog>
                
                <Dialog open= {this.state.openModalFact}                            
                        TransitionProps={{ onEntering: this.onEnteringFact }} 
                        classes = {{ paper: classes.paperFact }}>
                 <DialogTitle><Typography component='span' variant='subtitle2'>Facturar</Typography>
                    <IconButton className={classes.closeButton} onClick={this.handleCloseFact} size="small">
                      <CloseIcon fontSize="small" />
                    </IconButton>
                 </DialogTitle>
                 <DialogContent>
                  <TextField label="Factura"
                             value={this.state.factura} 
                             variant="outlined"
                             fullWidth
                             InputProps={{
                              readOnly: true, 
                              }}
                             />
                  <TextField label="Monto" 
                             value={this.state.monto}
                             variant="outlined"
                             fullWidth
                             InputProps={{
                              readOnly: true,
                              endAdornment:  (<React.Fragment>
                                              <InputAdornment position="end">
                                              {this.state.loadingFact ?
                                               <CircularProgress color='secondary' size={22}/>
                                               :
                                               <IconButton onClick={this.handleInfoFact}
                                                           edge="end"
                                                           style={{ width: 23, height: 23 }}>
                                                 <InfoIcon style={{ color: colores.azul }} />
                                               </IconButton>
                                              }
                                              </InputAdornment>
                                              </React.Fragment>),
                              }}
                              className={classes.textFieldFrm}
                              />
                  <Select Label='Forma de pago'
                          Datos={this.state.datosSelectFormaPago} 
                          Selected={this.state.selectedFormaPago}
                          onChange={this.handleChangeSelect}
                          name="FormaPago"
                          Style={classes.formControlSelect}
                          Outlined
                          shrink={this.state.selectedFormaPago !== '' ? true : undefined}
                          />
                  <TextField label="Autorización" 
                             variant="outlined"
                             fullWidth
                             className={classes.textFieldFrm}
                             value={this.state.valueAutorizacion}
                             inputProps={{ ref: this.autorizacionRef, autoComplete: 'off', maxLength: 15 }}
                             InputProps={{ 
                              readOnly: this.state.selectedFormaPago === 0 || this.state.loadingFact ? true : false, 
                             }}
                             onChange={this.onChangeTextfield}
                             id="Autorizacion"
                             />
                   <Select Label='Moneda de pago'
                           Datos = {this.state.datosSelectMoneda} 
                           Selected= {this.state.selectedMoneda}
                           onChange={this.handleChangeSelect}
                           name="Moneda"
                           Style = {classes.formControlSelect}
                           Outlined
                           shrink={this.state.selectedMoneda !== '' ? true : undefined}
                          />
                   <TextField label="Recibido" 
                              variant="outlined"
                              fullWidth 
                              className={classes.textFieldFrm}
                              inputProps={{ ref: this.recibidoRef, inputMode: movil ? 'decimal' : undefined, autoComplete: 'off' }}
                              InputProps={{ 
                                readOnly: this.state.selectedFormaPago === 0 ? false : true,
                                inputComponent: NumberFormatCustom,
                                startAdornment: <InputAdornment position="start">{this.state.simboloMoneda}</InputAdornment>
                              }}
                              value={this.state.selectedFormaPago === 0 ? (isNaN(this.state.valueRecibido)?"":this.state.valueRecibido):this.state.valueRecibido}
                              onChange={this.onChangeTextfield1}
                              onKeyDown={funciones.onlyNumbers(this.recibidoRef, true, true, true)}
                              id="Recibido"
                              />
                              
                    <TextField label="Cambio" 
                               variant="outlined"
                               fullWidth 
                               className={classes.textFieldFrm}
                               style={{ marginBottom: 30 }}
                               InputProps={{
                                readOnly: true, 
                                startAdornment: <InputAdornment position="start">{this.state.simboloMoneda}</InputAdornment>
                                }}
                                value=/*{this.state.valueCambio}*/
                                {this.state.selectedFormaPago === 0 ? (isNaN(this.state.valueRecibido)?"":this.state.valueCambio):this.state.valueCambio}
                               />
                 </ DialogContent>
                 <DialogActions>
                  <BarraBotones botones={this.botones_facturar} />                  
                 </DialogActions>
                </Dialog>

                <Dialog open={this.state.openModalGest}                            
                        TransitionProps={{ onEntering: this.onEnteringGest }} 
                        classes={{ paper: classes.paperGest }}
                        fullScreen={movil}>
                 <DialogTitle><Typography component='span' variant='subtitle2'>Gestiones</Typography>
                    <IconButton className={classes.closeButton} onClick={this.handleCloseGest} size="small">
                      <CloseIcon fontSize="small" />
                    </IconButton>
                 </DialogTitle>
                 <DialogContent>
                  <div ref={this.tablaDialogRef} className="disableTouchOptions">  
                   <CustomTable 
                    Columns={columnsGest} 
                    Rows={this.state.rowsGest}
                    getRowId={RowIdGest}
                    DefaultHiddenColumnNames={['ID_GESTION']}
                    height={this.state.heightTableGest - 50}
                    loading={this.state.loadingGest} 
                    enabledFilterRows
                    FilteringColumnExtensions={settingFilter}
                    TableColumnExtensions={columnExtensionsGest}
                    columnWidths={columnExtensionsGest}
                    VirtualTable_cellComponent={VirtualTable_cellComponent(null, null, null)}
                    showSelectionColumn
                    Selection={this.state.selection}
                    ChangeSelection={this.changeSelection}
                    leftColumnsFixed={[TableSelection.COLUMN_TYPE]}
                    columnFixedCellComponent={ColumnFixed_cellComponent}
                   />                    
                  </div>
                  <Paper variant="outlined" style={{ marginTop: 15, height: 35, padding: 0 }} className="disableTouchOptions">
                  <Grid container spacing={0} alignItems="center" style={{ minHeight: "100%" }}>
                   <Grid item xs={6} style={{ paddingLeft: 22 }}>
                     <Typography variant="body1" style={{ fontWeight: "bold" }}>{"Cantidad: " + this.state.selection.length}</Typography>
                   </Grid>
                   <Grid item xs={6} style={{ paddingRight: 37, display: "flex", justifyContent: "flex-end" }}>
                    <Typography variant="body1" style={{ fontWeight: "bold" }}>{"Total: " + this.state.sumGestion}</Typography>
                   </Grid>
                  </Grid>
                  </Paper>
                 </ DialogContent>
                 <DialogActions ref={this.dialogActionRef}>
                 <BarraBotones botones={this.botones_gestion} /> 
		             </ DialogActions>
                </Dialog>

                <Dialog open={this.state.openModalFactDetail}                            
                        TransitionProps={{ onEntering: this.onEnteringDetail }} 
                        classes={{ paper: classes.paperDetail }}
                        fullScreen={movil}>
                 <DialogTitle><Typography component='span' variant='subtitle2'>Detalle de factura</Typography>
                    <IconButton className={classes.closeButton} onClick={this.handleCloseDetail} size="small">
                      <CloseIcon fontSize="small" />
                    </IconButton>
                 </DialogTitle>
                 <DialogContent>
                 <div style={{ textAlign: "center" }}>
                    <TextField label='Estudiante' id='txtdetalle' variant='outlined' className={classes.formControlSelectModPago} style={{marginRight:5}} disabled defaultValue={this.state.valueAutoComplete!==null?this.state.valueAutoComplete.CUENTA_ALUMNO+' - '+this.state.valueAutoComplete.NOMBRE_COMPLETO:null} />
                      {(()=>{
                        if (this.state.visibleModPago)
                        return (
                          <Select Label='Modalidad de pago'
                                  Datos={this.state.datosSelectModPago} 
                                  Selected={this.state.selectedModPago}
                                  onChange={this.handleChangeSelect}
                                  Style={classes.formControlSelectModPago}   
                                  name="ModPago"
                                  disabled={this.state.disabledModPago}   
                                  shrink={this.state.selectedModPago !== '' ? true : undefined}                           
                                  Outlined />
                          )
                      })()}
                 </ div>
                 <div ref={this.tablaDialogRef} className="disableTouchOptions">  
                  <CustomTable 
                    Columns={columnsFactDetail} 
                    Rows={this.state.rowsFactDetail}
                    getRowId={RowIdDetail}
                    height={this.state.visibleModPago && !movil ? 400 : 400 //this.state.heightTableFact - (movil && this.state.visibleModPago ? 50 : 0)
                    }
                    loading={this.state.loadingDetail} 
                    DefaultHiddenColumnNames={['ID_DETALLE']}
                    TableColumnExtensions={columnExtensionsDetail}
                    columnWidths={columnExtensionsDetail}
                    VirtualTable_cellComponent={VirtualTableDetail_cellComponent}
                    totalItems={totalSummaryItemsDetail}
                    totalItemComponent={ItemComponentDetail(this.state.rowsFactDetail)}
                    showSelectionColumn
                    selectionColumnWidth={40}
                    tableSelectionCellComponent={TableSelectionDetailCellComponent(this.state.idRowDetailSelected, this.handleClickDeleteDetail, this.state.permisoEliminarGestion)}
                    rowSelected={this.state.idRowDetailSelected}
                    rowClick={this.handleRowDetailClick}
                    leftColumnsFixed={[TableSelection.COLUMN_TYPE]}
                    columnFixedCellComponent={ColumnFixed_cellComponent}
                   />                    
                  </div>
                 </ DialogContent>
                 <DialogActions ref={this.dialogActionRef} />
                </Dialog>

                <Dialog open={this.state.openBackDrop ? false : this.state.openModalConfirm}
                        classes={{ paper: classes.paperConfirm }}>
                 <DialogTitle><Typography component='span' variant='subtitle2'>{this.state.titleModal}</Typography>
                   <IconButton className={classes.closeButton} onClick={this.handleCloseConfirm} size="small">
                    <CloseIcon fontSize="small" />
                   </IconButton>
                 </DialogTitle>
                 <DialogContent style={{ paddingTop: "20px", textAlign: "center" }}>
                   <Typography variant="body1" gutterBottom>                
                    {this.state.textModal}
                   </Typography>    
                  </DialogContent>                       
                  <DialogActions style={{ marginTop: '20px'}}>
                   {(()=>{ 
                     if (this.state.openModalFactDetail)
                      return (<BarraBotones botones={this.botones_eliminar_dtl} />)

                      return (<BarraBotones botones={this.botones_reversar} />)
                    })()}
                   </DialogActions>
                  </Dialog>

                  <Dialog open= {this.state.openModalDate}
                          classes = {{ paper: classes.paperDate }}>
                   <DialogTitle><Typography component='span' variant='subtitle2'>Fecha de proceso</Typography>
                    <IconButton className={classes.closeButton} onClick={this.handleCloseDate} size="small">
                     <CloseIcon fontSize="small"/>
                    </IconButton>
                   </DialogTitle>
                   <DialogContent style = {{ justifyContent: 'center' }}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                        <KeyboardDatePicker                                     
                          variant="static"
                          inputVariant="outlined"
                          format="dd / MM / yyyy"
                          value={this.state.selectedDate}
                          onChange={this.handleDateChange}                                  
                          PopoverProps={{ style: {zIndex: 400500} }}
                          disableToolbar/>                                                            
                     </MuiPickersUtilsProvider>                         
                     </DialogContent>
                    <DialogActions>
                     <BarraBotones botones={this.botones_fecha} />
                    </DialogActions>
                  </Dialog>
                  
                  <Dialog open= {this.state.openModalRpt}
                          classes = {{ paper: classes.paperConfirm }}>
                   <DialogTitle><Typography component='span' variant='subtitle2'>Estado de cuenta</Typography>
                    <IconButton className={classes.closeButton} onClick={this.handleCloseRpt} size="small">
                     <CloseIcon fontSize="small"/>
                    </IconButton>
                   </DialogTitle>
                   <DialogContent>
                   <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                     <KeyboardDatePicker                        
                        variant="inline"
                        inputVariant="outlined"
                        format="dd / MM / yyyy"                                    
                        label="Desde"
                        value={this.state.selectedDateIni}
                        onChange={this.handleDateChangeIni}                                                                                                                                                                                
                        InputProps={{ style:{ paddingRight: '5px' }, readOnly: true }}   
                        KeyboardButtonProps={{ style: { width: 23, height: 23 } }}
                        autoOk
                        fullWidth
                        ToolbarComponent={CustomToolbar}
                        PopoverProps={{ style: { zIndex: 400500 } }}
                        />                                                            
                     </MuiPickersUtilsProvider>   
                     <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                     <KeyboardDatePicker                        
                        variant="inline"
                        inputVariant="outlined"
                        format="dd / MM / yyyy"                                    
                        label="Hasta"
                        margin="normal"
                        value={this.state.selectedDateFin}
                        onChange={this.handleDateChangeFin}                                                                                                                                                                                
                        InputProps={{ style:{ paddingRight: '5px' }, readOnly: true }}   
                        KeyboardButtonProps={{ style: { width: 23, height: 23 } }}
                        autoOk
                        fullWidth
                        ToolbarComponent={CustomToolbar}
                        PopoverProps={{ style: { zIndex: 400500 } }}
                        style={{ marginBottom: 30 }}
                        />                                                            
                     </MuiPickersUtilsProvider>                    
                   </DialogContent>
                  <DialogActions>
                    <BarraBotones botones={this.botones_rpt} />
                  </DialogActions>
                  </Dialog>
                  
                  {(()=>{ 
                   if (this.state.parametros !== null) 
                   return(
                        <Reporte label_reporte="ESTADODECUENTA" 
                          id="BTFAC-EC"
                          parametros={this.state.parametros}
                          nom_boton="" 
                          nom_bar="Estado de Cuenta"  
                          fill="white" 
                          fullScreen 
                          boton={false}
                          opciones={false} 
                          color_bar='primary'/>
                   )
                  })()}
    
    
                        <Reporte label_reporte="Detalle de Cuenta" 
                          id="BTFAC-DET"
                          parametros={this.state.parametros}
                          nom_boton="" 
                          nom_bar="Detalle de Factura"
                          fill="white" 
                          fullScreen
                          boton={false}
                          opciones={false} 
                          color_bar='primary'/>
  

                  <Popover
                    open={this.state.openMenu}
                    anchorReference='anchorPosition'
                    anchorPosition={{ top: this.buttonMenuRef.current !== null ? this.buttonMenuRef.current.getBoundingClientRect().top : 0, left: this.buttonMenuRef.current !== null ? this.buttonMenuRef.current.getBoundingClientRect().left : 0 }}
                    elevation={24}                    
                    style={{ zIndex: 500000 }}                    
                   >
                <ClickAwayListener onClickAway={this.handleCloseMenuTable(null)} mouseEvent='onMouseDown' touchEvent='onTouchStart'>
                   <MenuList>
                    <MenuItem onClick={this.handleCloseMenuTable(1)}>
                     <ListItemIcon>
                       <Crop54Icon fontSize="small" style={{ color: colores.azul }} />
                     </ListItemIcon>
                     Detalle
                    </MenuItem>
                    <MenuItem onClick={this.handleCloseMenuTable(2)} disabled={this.state.disabledOptionMenuRev || !this.state.permisoReversar}>
                     <ListItemIcon>
                       <RestoreIcon fontSize="small" style={{ color: colores.azul }} />
                     </ListItemIcon>
                     Reversar
                    </MenuItem>
                    <MenuItem onClick={this.handleCloseMenuTable(3)} disabled={this.state.disabledOptionMenuImp || !this.state.permisoEstadoCuenta}>
                     <ListItemIcon>
                      <PrintIcon fontSize="small" style={{ color: colores.azul }} />
                     </ListItemIcon>
                      Reimprimir recibo
                    </MenuItem>
                    </MenuList>   
                </ClickAwayListener>

              </Popover>

                  <Backdrop className={classes.backdrop}
                            open={this.state.openBackDrop}>                                       
                    <CircularProgress color="inherit" />
                    <span style={{ marginTop: '10px' }}>{this.state.textbackdrop}</span>
                  </Backdrop>
                  <Backdrop open={this.state.loadingClientes || this.state.loadingMain || this.state.loadingFact || this.state.loadingGest || this.state.loadingDetail}
                            className={classes.backdrop} 
                            invisible 
                            transitionDuration={0}/>

                </React.Fragment>
              );

             }             
             
            })()

          }

          
        </Paper>
      </React.Fragment>
  );
  }
else if (this.state.isLoggin === false)
{
  //Auth.logout();
  window.location.reload();
  return; //((<Redirect to="/login"/>))
}
return null;

}//FIN RENDER
}

)